




































import Vue from 'vue';
import Card from '~/components/profile/cards/Card.vue';
import LanguagesModal from '~/components/profile/modals/LanguagesModal.vue';
import { commonProps } from '~/utils/candidate';

export default Vue.extend({
    name: 'Languages',
    components: {
        Card,
        LanguagesModal,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasNoLanguages(): boolean {
            return !this.candidate.languages.length;
        },
        cardTitle(): string {
            return this.hasNoLanguages
                ? this.$t('profile.languages.titleWhenEmpty').toString()
                : this.$t('profile.languages.title').toString();
        },
    },
});
